import angular = require("angular");
import TPL = require("templates");
import {EventType, MealType, AlcoholType, DietType} from "../../models/data";

export class TypePickerDirective {

  template = TPL.contentDirectives.typePicker;
  scope = {
    params: "=params",
    form: "=form",
    alcohol: "=alcohol",
    meal: "=meal",
    dietary: "=dietary",
  };


  link;

  constructor(session) {

    this.link = (scope, el, attrs) => {
      scope.vm = {
          session: session,
          mealTypeOptions: [
            MealType.HOME_COOKED,
            MealType.ORDERED_IN,
            MealType.BUFFET
          ],
          alcoholTypeOptions: [
            AlcoholType.HOST_PROVIDES,
            AlcoholType.BYOB,
            AlcoholType.ALCOHOL_FREE
          ],
          dietTypeOptions: [
            DietType.VEGETARIAN,
            DietType.VEGAN,
            DietType.GLUTEN_FREE,
            DietType.KOSHER
          ]
      }
    }
  }

  static factory() {
    var tmp = (a) => new TypePickerDirective(a);
    tmp.$inject = ["session"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/typePicker.ts
 **/